export default (amazonpayData) => {
  let defaultAmazonpayObject = {
    merchantId: amazonpayData?.merchantId,
    ledgerCurrency: amazonpayData?.amazonpayLedgerCurrency,
    productType: 'PayAndShip',
    placement: 'Other',
    checkoutLanguage: amazonpayData?.amazonpayCheckoutLanguage,
    createCheckoutSessionConfig: {
      payloadJSON: amazonpayData?.jsonPayload,
      signature: amazonpayData?.signature,
    },
  };
  
  if (amazonpayData.amazonpayEnvironmentIsSandbox !== undefined) {
    defaultAmazonpayObject = {...defaultAmazonpayObject, sandbox: amazonpayData.amazonpayEnvironmentIsSandbox};
  }
  
  if (amazonpayData.amazonpaySetPublicKeyOnTopLevel) {
    defaultAmazonpayObject = {...defaultAmazonpayObject, publicKeyId: amazonpayData.publicKeyId};
  } else {
    defaultAmazonpayObject = {
      ...defaultAmazonpayObject,
      createCheckoutSessionConfig: {
        ...defaultAmazonpayObject.createCheckoutSessionConfig,
        publicKeyId: amazonpayData.publicKeyId,
      },
    };
  }
  
  if (window.amazon?.Pay && typeof window.amazon?.Pay?.initCheckout === 'function') {
    window.amazon.Pay.initCheckout(defaultAmazonpayObject);
  } else {
    throw Error('Amazon pay error amazon.Pay.initCheckout does not exist on the window or is not a function');
  }
};
